import React, { useState, useEffect } from "react";
import {
    Button,
    Card, Collapse, Grid, Paper, Typography
} from "@material-ui/core";
import useStyles from "./styles";

import EducationCenter from './../../assets/img/icons/EducationCareer.svg';
import Utilities from './../../assets/img/icons/Utilities.svg';
import InfoAndEntertainment from './../../assets/img/icons/InfoAndEntertainment.svg';
import Sports from './../../assets/img/icons/Sports.svg';

import Health from './../../assets/img/icons/Health.svg';
import NewPackageOffers from './../../assets/img/icons/NewPackageOffers.svg';
import EducationCareer from './../../assets/img/icons/EducationCareer.svg';
import ServicesReview from './../../assets/img/icons/ServicesReview.svg';





function DigitalServices({ ...props }) {
    const classes = useStyles();

    return (
        <>
            <div className={classes.appBarSpacer} />
            <div className={classes.header}>
                <Typography component="h2">Digital Services </Typography>
            </div>
            <Grid className={classes.container}>

                <Grid container>

                    <Grid item xs={6} sm={6} lg={3} md={3}>
                        <div className={classes.greyBorderBox}>
                            <img src={EducationCenter} alt="" />
                            <h3>Music and Videos</h3>
                        </div>
                    </Grid>

                    <Grid item xs={6} sm={6} lg={3} md={3}>
                        <div className={classes.greyBorderBox}>
                            <img src={Utilities} alt="" />
                            <h3>Utilities</h3>
                        </div>
                    </Grid>

                    <Grid item xs={6} sm={6} lg={3} md={3}>
                        <div className={classes.greyBorderBox}>
                            <img src={InfoAndEntertainment} alt="" />
                            <h3>Info and Entertainment</h3>
                        </div>
                    </Grid>

                    <Grid item xs={6} sm={6} lg={3} md={3}>
                        <div className={classes.greyBorderBox}>
                            <img src={Sports} alt="" />
                            <h3>Sports</h3>
                        </div>
                    </Grid>

                    <Grid item xs={6} sm={6} lg={3} md={3}>
                        <div className={classes.greyBorderBox}>
                            <img src={Health} alt="" />
                            <h3>Health</h3>
                        </div>
                    </Grid>

                    <Grid item xs={6} sm={6} lg={3} md={3}>
                        <div className={classes.greyBorderBox}>
                            <img src={NewPackageOffers} alt="" />
                            <h3>New Packages & offers</h3>
                        </div>
                    </Grid>

                    <Grid item xs={6} sm={6} lg={3} md={3}>
                        <div className={classes.greyBorderBox}>
                            <img src={EducationCareer} alt="" />
                            <h3>Education & Career</h3>
                        </div>
                    </Grid>

                    <Grid item xs={6} sm={6} lg={3} md={3}>
                        <div className={classes.greyBorderBox}>
                            <img src={ServicesReview} alt="" />
                            <h3>Services Review</h3>
                        </div>
                    </Grid>

                </Grid>
            </Grid>
        </>
    )
}
export default DigitalServices;